import {
	CartesianGrid,
	Line,
	LineChart,
	ResponsiveContainer,
	Tooltip,
	TooltipProps,
	XAxis,
	YAxis
} from "recharts";

import { Amt, Bar, Card, CardAmount, CardFooter, CardInfo, CardOrderTitle, CardTitle, CardTodayButton, CustomTool, Info, InfoLabels, LabelFooter, Pct, Txt, TxtTool } from './styles';

interface DataType {
	time: string;
	value: number;
}

export interface Product {
	percentage: string;
	atm: string;
	title: string;
}

//Grafica de Linea
const CustomTooltip = ({ payload, active }: TooltipProps<any, string>) => {
	if (active && payload && payload.length) {
		const value = payload[0].value;
		const formattedValue = Number(value).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
		return (
			<CustomTool >
				<TxtTool>Monto: ${formattedValue}</TxtTool>
			</CustomTool>
		);
	}
	return null;
};

interface GraphicsAmountProps {
	data?: DataType[];
	totalAmount?: string;
}

export const GraphicsAmount = ({ data, totalAmount }: GraphicsAmountProps) => {
	return <>
		<Card>
			<CardOrderTitle>
				<CardTitle>Monto recaudado</CardTitle>
				<CardTodayButton>Últimas 24 horas</CardTodayButton>
			</CardOrderTitle>
			<CardAmount>{totalAmount || "$0"}</CardAmount>
			<CardInfo>
				<ResponsiveContainer height={180}>
					<LineChart data={data} >
						<CartesianGrid strokeDasharray="5 5" stroke="#F2F2F2" horizontal={false} />
						<XAxis dataKey="time" axisLine={false} tick={{ fill: "#646174" }} fontSize={12} tickMargin={12} />
						<YAxis minTickGap={1} axisLine={false} tick={{ fill: "#646174" }} tickLine={true} fontSize={12} tickMargin={12} />
						<Tooltip content={<CustomTooltip />} />

						<Line type="linear" dataKey="value" stroke="#141432" strokeWidth={3} dot={{ stroke: "#141432", strokeWidth: 2, fill: "white", r: 4 }} />
					</LineChart>
				</ResponsiveContainer>
			</CardInfo>
		</Card></>
}

//Grafica de barra
interface GraphicsAmountMeansProps {
	data: Product[] | undefined;
	totalAmount?: string;
}

export const GraphicsAmountMeans = ({ data, totalAmount }: GraphicsAmountMeansProps) => {
	return (
		<Card>
			<CardOrderTitle>
				<CardTitle>Por medio de pago</CardTitle>
				<CardTodayButton>Últimas 24 horas</CardTodayButton>
			</CardOrderTitle>
			<CardAmount>{totalAmount}</CardAmount>
			<div style={{ display: "flex", flexDirection: "row" }}>
				{data && data.map((item, index) => (
					item.percentage != "0%" && <Info key={index} width={item.percentage}>
						<InfoLabels>
							<Amt>{item.atm}</Amt>
							<Txt>{item.title}</Txt>
						</InfoLabels>
						<InfoLabels>
							<div style={{ display: "flex", alignItems: "flex-end" }}>
								<Pct color={index > 0 ? undefined : "yes"}>{item.percentage}</Pct>
							</div>
							<Bar color={index > 0 ? undefined : "yes"} />
						</InfoLabels>
					</Info>
				))}
			</div>
			<CardFooter>
				<LabelFooter>0</LabelFooter>
				<LabelFooter>{totalAmount}</LabelFooter>
			</CardFooter>
		</Card>
	);
};